import { render, staticRenderFns } from "./AccettazioneRicettaPrestazioniListaComponent.vue?vue&type=template&id=d9389a66&scoped=true"
import script from "./AccettazioneRicettaPrestazioniListaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneRicettaPrestazioniListaComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneRicettaPrestazioniListaComponent.vue?vue&type=style&index=0&id=d9389a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9389a66",
  null
  
)

export default component.exports